import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Map"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M7.4328 11.55L12.0003 18L16.6503 11.445C17.5247 10.3533 18.0009 8.9962 18.0003 7.5975C18.0211 4.25934 15.3384 1.53299 12.0003 1.5C9.63937 1.53524 7.51043 2.92876 6.53348 5.07837C5.55653 7.22798 5.90675 9.74821 7.4328 11.55ZM13.4863 6.75C13.4863 7.57843 12.8148 8.25 11.9863 8.25C11.1579 8.25 10.4863 7.57843 10.4863 6.75C10.4863 5.92157 11.1579 5.25 11.9863 5.25C12.8148 5.25 13.4863 5.92157 13.4863 6.75ZM20.9863 9H19.4863V10.5H20.9863V21H2.98633V10.5H4.48633V9H2.98633C2.1579 9 1.48633 9.67157 1.48633 10.5V21C1.48633 21.8284 2.1579 22.5 2.98633 22.5H20.9863C21.8148 22.5 22.4863 21.8284 22.4863 21V10.5C22.4863 9.67157 21.8148 9 20.9863 9ZM7.50025 7.5975C7.47525 5.08607 9.48886 3.02884 12.0002 3C14.5116 3.02884 16.5252 5.08607 16.5002 7.5975C16.4949 8.6532 16.1328 9.67608 15.4727 10.5L12.0002 15.39L8.61775 10.5975C7.90133 9.76163 7.50527 8.69837 7.50025 7.5975Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Map.vue"]]);
